/* src/app/core/pages/error/error.component.scss */
.error_container {
  margin-left: 18%;
}
/*# sourceMappingURL=error.component.css.map */
